// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2DmTE","footer":"ModalFilter_footer__2zjHY"};